import DocumentMeta from "component/design-system/DocumentMeta";
import { useTranslation } from "next-i18next";
import commonTitleStyles from "resources/common-css/commonTitle.module.scss";
import commonSectionStyles from "resources/common-css/commonSection.module.scss";
import VizSensor from "../../component/design-system/VizSensor";

const meta = {
  title: "PartsAvatar.ca: Find top jobs in Automotive e-commerce in Canada",
  description: "Contact us if you're interested in a career with a fast growing Canadian autoparts company for IT, Java, Jobbers, Mechanics, Warehouse, and auto parts work",
  meta: {
    robots: "all",
    name: {
      title: "Exciting Careers in Aftermarket AutoParts Industry",
      keywords: "aftermarket work,careers in automotive industry,auto sector jobs,car parts industry jobs,parts warehouse job,canada auto employment,partsavatar human resource,full time technology jobs,ecommerce canada job,java developer auto parts,online jobs canada,mechanics jobs",
    },
  },
};

export default function Careers() {
  const { t } = useTranslation("static-pages");
  return (
    <div className="careers container">

      <DocumentMeta {...meta} />

      <div className={commonTitleStyles.common_title}>{t("Career")}</div>

      <div className={commonSectionStyles.common_section}>{t("Partner with Us")}</div>

      <img
        alt="join-our-team"
        src={`${process.env.NEXT_PUBLIC_ROOT_URL}/images/career/join-our-team.jpg`}
        className="img-responsive center-block"
        style={{ width: "80%" }}
      />

      <div className="m-t-20 m-b-20">

        <p>{t("career_description")}</p>
      </div>

      <div className={commonSectionStyles.common_section}>{t("Join Our Team")}</div>

      <div className="row row-5-padding">

        <div className="col-sm-6">

          <VizSensor>

            <img
              alt="warehouse-team"
              src={`${process.env.NEXT_PUBLIC_ROOT_URL}/images/career/warehouse-team.jpg`}
              className="img-responsive center-block"
            />
          </VizSensor>
        </div>

        <div className="col-sm-6 hidden-xs">

          <VizSensor>

            <img
              alt="holding-laptop"
              src={`${process.env.NEXT_PUBLIC_ROOT_URL}/images/career/holding-laptop.jpg`}
              className="img-responsive center-block"
            />
          </VizSensor>
        </div>
      </div>

      <div className="m-t-20 m-b-20">

        <p>{t("career_fast_growing")}</p>
      </div>

      <div className={commonSectionStyles.common_section}>{t("Current Openings")}</div>

      <VizSensor>

        <img
          alt="hand-shake"
          src={`${process.env.NEXT_PUBLIC_ROOT_URL}/images/career/hand-shake.jpg`}
          className="img-responsive center-block"
          style={{ width: "80%" }}
        />
      </VizSensor>

      <div className="m-t-20">

        <p>{t("career_lookout")}</p>
      </div>

      <div className="m-t-20">

        <p>
          {t("Browse current openings at")}
          {" "}

          <a
            href="http://ca.indeed.com/cmp/Partsavatar.ca"
            rel="noopener noreferrer"
            target="_blank"
            className="external-link"
          >
            Indeed.ca

          </a>

          <br />
          {t("Browse current openings at")}
          {" "}

          <a
            href="https://www.glassdoor.ca/Overview/Working-at-Parts-Avatar-EI_IE1143606.11,23.htm"
            rel="noopener noreferrer"
            target="_blank"
            className="external-link"
          >
            Glassdoor.ca

          </a>
        </p>
      </div>

      <div className="m-t-20">

        <p>
          {`${t("career_contact")} `}

          <span className="email-value">HR@partsavatar.ca</span>
        </p>
      </div>

    </div>
  );
}
